<template>
  <div class="company-list">
    <span class="title">绿色企业名单</span>
    <div class="company-list-body">
      <div class="search-content">
        <div class="select-searchmain1">
          <div class="earch-input">
            <div class="input-li2">
              <p>请选择年度：</p>
              <el-date-picker
                size="small"
                style="width: 100%"
                :clearable="false"
                v-model="searchParams.year"
                value-format="yyyy"
                format="yyyy年"
                type="year"
                :picker-options="pickerOptions"
                placeholder="选择年"
              >
              </el-date-picker>
            </div>
            <div class="input-li2">
              <p>企业名称：</p>
              <el-input
                size="small"
                placeholder="请输入企业名称关键字"
                v-model="searchParams.name"
              >
              </el-input>
            </div>
            <div class="input-li2">
              <p>统一社会信用代码：</p>
              <el-input
                size="small"
                placeholder="请输入企业名称关键字"
                v-model="searchParams.code"
              >
              </el-input>
            </div>
            <div class="input-li2">
              <p>选择辖区</p>
              <el-select
                style="width: 100%"
                size="small"
                filterable
                clearable
                v-model="searchParams.jurisdiction"
                placeholder="请选择所在辖区"
              >
                <el-option
                  v-for="item in jurisdiction"
                  :key="item.Key"
                  :label="item.Value"
                  :value="item.Key"
                >
                </el-option>
              </el-select>
            </div>

            <div class="input-li2">
              <p>行业类别</p>
              <el-cascader
                placeholder="请选择行业类别"
                ref="industryCas"
                size="small"
                clearable
                :show-all-levels="false"
                style="width: 100%"
                collapse-tags
                v-model="searchParams.industry"
                :props="industriesProps"
                :options="industries"
                filterable
              >
              </el-cascader>
            </div>
            <div class="input-li2">
              <p>联系人</p>
              <el-input
                size="small"
                placeholder="请输入联系人"
                v-model="searchParams.wasteContact"
              >
              </el-input>
            </div>
            <div style="display: inline-block">
              <el-button size="small" @click="downloadTable()">下载</el-button>
              <el-button size="small" plain @click="onReset()">重置</el-button>
              <el-button size="small" type="primary" @click="getList()"
                >查询</el-button
              >
            </div>
          </div>
        </div>
      </div>
      <el-table
        size="small"
        height="calc(100% - 250px)"
        :header-cell-style="{
          background: '#f5f5f5',
          color: '#000',
        }"
        :data="dataSource"
        style="width: 100%; margin-bottom: 20px"
        row-key="id"
        border
      >
        <el-table-column align="center" label="序号" width="80">
          <template scope="scope">
            <span>{{
              (pagination.current - 1) * pagination.pageSize + scope.$index + 1
            }}</span>
          </template>
        </el-table-column>

        <el-table-column align="center" prop="name" label="企业名称">
          <template slot-scope="{ row }">
            <span @click="detail(row)" class="company-name-link">{{
              row.name
            }}</span>
            <!-- <router-link :to="{
              name: 'cfCompanyDetail',
              params: {
                companyId: row.companyId,
                manageType: '产废单位',
                companyName: row.name,
                returnName: 'zfGreenCompanies'
              }
            }">{{ row.name }}</router-link> -->
          </template>
        </el-table-column>
        <el-table-column
          align="center"
          prop="uniformSocialCreditCode"
          label="统一社会信用代码"
        >
        </el-table-column>
        <el-table-column align="center" prop="jurisdiction" label="所属辖区">
          <!-- <template slot-scope=" { row }">
            {{ jurisdiction.find(j => j.Key == row.jurisdiction)?.Value }}
          </template> -->
        </el-table-column>

        <el-table-column align="center" prop="industry2017s" label="行业类别">
          <template slot-scope="{ row }">
            {{ getIndustry2017sName(row.industry2017s) }}
          </template>
        </el-table-column>
        <el-table-column
          align="center"
          prop="basicValue"
          label="园区年度危废产生量（吨）/园区年度万元产值"
        >
          <template slot-scope="{ row }">
            {{ row.basicValue?.toFixed(5) }}
          </template>
        </el-table-column>
        <el-table-column
          align="center"
          prop="companyValue"
          label="年度危废产生量（吨）/年度万元产值"
        >
          <template slot-scope="{ row }">
            {{ row.companyValue?.toFixed(5) }}
          </template>
        </el-table-column>
        <el-table-column align="center" prop="wasteContact" label="联系人">
        </el-table-column>
        <el-table-column align="center" prop="mobile" label="联系方式">
        </el-table-column>
      </el-table>
      <div class="paaination">
        <el-pagination
          background
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
          :current-page="pagination.current"
          :page-sizes="pagination.pageSizeOptions"
          :page-size="pagination.pageSize"
          layout="total, sizes, prev, pager, next, jumper"
          :total="pagination.total"
        >
        </el-pagination>
      </div>
    </div>
    <companyDetail ref="companyDetail"></companyDetail>
  </div>
</template>

<script>
import companyDetail from "@/components/companyDetail.vue";

import { DownloadBlob } from "@/http/downloadService";
import { paginations } from "@/../utils/public";
export default {
  components: { companyDetail },
  data() {
    return {
      dataSource: [],
      searchParams: {
        name: "",
        year: `${new Date().getFullYear() - 1}`,
        code: "",
        jurisdiction: null,
        industry: "",
        wasteContact: "",
      },
      pickerOptions: {
        disabledDate(time) {
          return time.getFullYear() >= new Date().getFullYear();
        },
      },
      jurisdiction: [],
      industries: [],
      industriesProps: {
        multiple: false,
        value: "industryCode",
        label: "industryName",
        emitPath: false,
      },
      pagination: {
        current: paginations.page,
        pageSize: paginations.limit,
        total: paginations.total,
        pageSizeOptions: paginations.pageSizes,
      },
    };
  },
  computed: {},
  methods: {
    downloadTable() {
      let url = this.$api.companies.downloadGreenCompanies;

      const data = this.searchParams;
      DownloadBlob({
        url: url,
        data: data,
        method: "get",
      });
    },
    detail(row) {
      console.log(row, "greenrow");
      this.$refs.companyDetail.getCompanyInfo(row);
    },
    getIndustry2017sName(data) {
      return data.map((d) => d.industryName).join("，");
    },
    getList() {
      const parames = {
        ...this.searchParams,
        pageSize: this.pagination.pageSize,
        pageNum: this.pagination.current,
        getTotal: true,
      };
      const url = this.$api.companies.getGreenCompanies;
      this.$axios.get(url, parames, false).then((res) => {
        if (res.data.code == 0) {
          let { companies, total } = res.data.data;

          this.pagination.total = total;
          this.dataSource = companies;
        } else {
          this.$message({
            message: "加载数据失败，请重试",
            type: "error",
          });
        }
      });
    },
    getParams() {
      const url = this.$api.companies.getParams;
      this.$axios.get(url, false).then((res) => {
        if (res.data.code == 0) {
          let { jurisdiction, industries } = res.data.data;
          this.jurisdiction = jurisdiction;
          this.industries = industries;
        } else {
          this.$message({
            message: "加载数据失败，请重试",
            type: "error",
          });
        }
      });
    },
    // 分页切换方法
    onPage(current, pageSize) {
      this.pagination.current = current;
      this.pagination.pageSize = pageSize;
      this.getList();
    },

    onReset() {
      this.pagination = {
        current: paginations.page,
        pageSize: paginations.limit,
        total: paginations.total,
        pageSizeOptions: paginations.pageSizes,
      };
      // 重置时清空搜索数据
      this.searchParams = {
        name: "",
        year: `${new Date().getFullYear() - 1}`,
        code: "",
        jurisdiction: null,
        industry: "",
        wasteContact: "",
      };
      this.getList();
    },
    handleSizeChange(val) {
      this.pagination.pageSize = val;
      this.getList();
    },
    handleCurrentChange(val) {
      this.pagination.current = val;
      this.getList();
    },
  },

  mounted() {
    this.getParams();
    this.getList();
  },
};
</script>

<style lang="scss" scoped>
.company-list {
  height: 100%;

  .title {
    font-size: 18px;
    font-weight: bold;
    border-left: 8px solid #1890ff;
    padding-left: 12px;
  }

  .date-select {
    padding-bottom: 5px;
  }

  .company-list-body {
    height: calc(100% - 21px);
    padding-top: 5px;
    padding: 5px 15px;

    .paaination {
      float: right;
    }
  }

  .select-searchmain1 {
    width: 100%;
    // height: 70px;
    // display: flex;
    padding: 10px;
    box-sizing: content-box;

    .search-action {
      // display: inline-block;
      // width: 320px;
      text-align: center;
      height: 100%;
      line-height: 70px;
    }

    .earch-input {
      flex-grow: 1;
      padding-left: 20px;

      p {
        width: 100%;
        height: 30px;
        line-height: 30px;
      }

      .input-li2 {
        margin-right: 20px;
        width: 260px;
        font-size: 12px;
        display: inline-block;

        .el-input {
          line-height: 40px;
        }
      }

      .input-li {
        margin-right: 20px;
        width: 200px;
        font-size: 12px;
        display: inline-block;

        .el-input {
          line-height: 40px;
        }
      }
    }
  }

  .company-name-link {
    color: #1890ff;
    cursor: pointer;
  }
}
</style> 